module.exports = __webpack_public_path__ + "static/media/Slide8.a27cfb3d.png";